import { IDomain } from "@bprotsyk/aso-core";
import { useCallback, useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  CheckPicker,
  Input,
  InputGroup,
  Message,
  Progress,
  Stack,
  Table,
  toaster,
  Uploader,
} from "rsuite";
import SearchIcon from "@rsuite/icons/Search";
import ContainerTable from "./table/table";
import "./_domains.scss";
import AddDomainModal from "../../../ui/modals/domains/add-domains";
import EditingRecordsModal from "../../modals/domains/host-settings";
import BuyDomainModal from "../../../ui/modals/domains/buy-domain";
import React from "react";
import StaticModal from "../../../ui/modals/domains/add-static-files";
import { title } from "process";
import CustomFilterPicker from "./custom-filter-picker";
import ArchivedDomainsModal from "ui/modals/domains/archive-modal";
import { FileType } from "rsuite/esm/Uploader";
import { PanelService } from "network/panel/network";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { faCopy, faCheck, faTimes, faInfoCircle, faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import { Column, HeaderCell, Cell } from 'rsuite-table';
import DeployModal from "../../modals/domains/deploy-modal";

const PREF_NAMECHEAP_BALANCE = "namecheap-balance";
const PREF_FILTER_SHOW_ARCHIVED = "filter-selector";
const DEPLOY_STATUS = "delpoy_status";
const placement = "topEnd";
let previousValue = sessionStorage.getItem(DEPLOY_STATUS);

// Header height constants
const HEADER_HEIGHT = 56; // Main header height
const SUB_HEADER_HEIGHT = 64; // Sub-header height
const TOTAL_HEADER_HEIGHT = HEADER_HEIGHT + SUB_HEADER_HEIGHT;

interface ISearchInput {
  search: string;
  setSearch: (value: string) => void;
}
const nameCheapInit = () => {
  return parseFloat(localStorage.getItem(PREF_NAMECHEAP_BALANCE) || "0");
};
interface FilterState {
  status: string[];
  archived: string[];
  target: string[];
}

interface IStaticDeploy {
  file: File;
  name: string;
}

// search input
const CustomInputGroup = ({ search, setSearch }: ISearchInput) => (
  <div className="lists-search">
    <input
      type="text"
      placeholder="Пошук..."
      value={search}
      onChange={e => setSearch(e.target.value)}
      className="lists-search-input"
    />
    <FontAwesomeIcon icon={faSearch} className="lists-search-icon" />
  </div>
);

export default function DomainsPage() {
  let [namecheapBalance, setNamecheapBalance] = useState<number>(
    nameCheapInit()
  );
  const [toglleModallAddDomain, setTogllerModallAddDomain] =
    useState<boolean>(false);

  const [toglleModallBuyDomain, setToglleModallBuyDomain] =
    useState<boolean>(false);

  const [toglleModallEditingDomain, setToglleModallEditingDomain] =
    useState<boolean>(false);

  const [toglleModallEditingStatic, setToglleModallEditingStatic] =
    useState<boolean>(false);

  const [toglleModallArchive, setToglleModallArchive] =
    useState<boolean>(false);

  const [toglleModallDeploy, setToglleModallDeploy] =
    useState<boolean>(false);

  const [editingDomain, setEditingDomain] = useState<IDomain | any>(null);
  const [data, setData]=useState<IDomain[]>([]);
  const [toggleButtonShow, setToggleButtonShow] = useState<boolean>(false);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState<FilterState>(() => {
    const localFilter = localStorage.getItem(PREF_FILTER_SHOW_ARCHIVED);
    if (localFilter) return JSON.parse(localFilter);
    return { status: [], archived: [], target: [] };
  });

  const [archivedDomains, setArchivedDomains] = useState([]);
  const [load, setLoad] = useState(false);
  const [tableHeight, setTableHeight] = useState(window.innerHeight - TOTAL_HEADER_HEIGHT);
  // TODO ne peovtikay zberigari balans i
  // zaprashuvati kojnogo razu pisla pokupki i prosto onEffect([])
  const getTableData = () => {
    PanelService.getDomains().then((res) => setData(res));
  };

  useEffect(() => {
    PanelService.getDomainBalance().then((res) => {
      setNamecheapBalance(res);
      const resToString = String(res);
      localStorage.setItem(PREF_NAMECHEAP_BALANCE, resToString);
    });
    getTableData()
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setTableHeight(window.innerHeight - TOTAL_HEADER_HEIGHT);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  const handleAddDomains = () => {
    setTogllerModallAddDomain(!toglleModallAddDomain);
  };

  const handleBuyDomains = () => {
    setToglleModallBuyDomain(!toglleModallBuyDomain);
  };

  const editingModal = () => {
    setToglleModallEditingDomain(!toglleModallEditingDomain);
  };

  const handleEditingDomain = (e: IDomain) => {
    editingModal();
    console.log(e);
    const updatedDomain = {
      ...e,
      txtRecords: e.txtRecords.length > 0 ? e.txtRecords : [],
    };

    setEditingDomain(updatedDomain);
  };

  const setEditStaticModal = () => {
    setToglleModallEditingStatic(!toglleModallEditingStatic);
  };

  const toggleButtonShowHidden = (e: boolean) => {
    setToggleButtonShow(e);
  };

  const toggleArchiveShowModal = () => {
    setToglleModallArchive(!toglleModallArchive);
  };

  const customFilters = (filterSelectors: FilterState) => {
    setFilter(filterSelectors);
    if (filterSelectors) {
      localStorage.setItem(
        PREF_FILTER_SHOW_ARCHIVED,
        JSON.stringify(filterSelectors)
      );
    }
  };

  const handleDeploy = () => {
    setToglleModallDeploy(!toglleModallDeploy);
   
  };

  const uploadStaticToServer = async (file: File) => {
    const name = editingDomain.name;
    setLoad(true);
    const body = {
      file,
      name: name,
    };
    console.log(body);
    await PanelService.uploadStatic(body);
    setLoad(false);
  };

  const message = (messageType: any, mesageText: string) => {
    return (
      <Message key={new Date().getTime()} showIcon type={messageType} closable>
        <strong>{mesageText}</strong>
      </Message>
    );
  };

  function checkSessionStorage() {
    const currentValue = sessionStorage.getItem(DEPLOY_STATUS);
    if (currentValue !== previousValue) {
      console.log(currentValue);
      previousValue = currentValue;
      if (currentValue === "true") {
        const messageText = "Всі файли успішно завантажені на сервер";

        toaster.push(message("success", messageText), {
          placement: placement,
          duration: 5000,
        });
      } else if (currentValue === "false") {
        const messageText =
          "Виникла помилка при спробі завантажити файли на сервер";
        toaster.push(message("error", messageText), {
          placement: placement,
          duration: 5000,
        });
        setLoad(false);
      }
    }
    sessionStorage.removeItem(DEPLOY_STATUS);
  }
  const domainUpdate = (updateData: Partial<IDomain>) => {
    setData((prevData: IDomain[]) => {
      if (!prevData) return prevData;

      const index = prevData.findIndex((domain) => domain.id === updateData.id);
      if (index === -1) return prevData;

      const updatedDomainData = [...prevData];
      updatedDomainData[index] = {
        ...updatedDomainData[index],
        ...updateData,
      } as IDomain;

      return updatedDomainData;
    });
  };

  const handleRenewDomain = async (domain: IDomain) => {
    try {
      console.log('🔄 Renewing domain:', domain.name);
      console.log('Domain data:', domain);

      const result = await PanelService.renewDomain({
        domainName: domain.name,
        years: 1 // Default to 1 year renewal
      });

      if (result.success) {
        toaster.push(
          <Message showIcon type="success" closable>
            Домен {domain.name} успішно поновлено! Нова дата закінчення: {new Date(result.data.expiredDate).toLocaleDateString('uk-UA')}
          </Message>,
          { placement: placement, duration: 5000 }
        );

        // Refresh the domain list to show updated expiration date
        getTableData();
      } else {
        toaster.push(
          <Message showIcon type="error" closable>
            Помилка при поновленні домену {domain.name}: {result.message}
          </Message>,
          { placement: placement, duration: 5000 }
        );
      }
    } catch (error: any) {
      console.error('Domain renewal error:', error);
      toaster.push(
        <Message showIcon type="error" closable>
          Помилка при поновленні домену {domain.name}: {error.message}
        </Message>,
        { placement: placement, duration: 5000 }
      );
    }
  };
  
  
  


  setInterval(checkSessionStorage, 500);

  console.log(data)

  

  return (
    <div className="domains">
      <div className="domains-header">
        <div className="domains-header-content">
          <span className="balance">
            Баланс Namecheap:{" "}
            <span className="balance-number">${namecheapBalance}</span>
          </span>
          <div className="domains-actions">
            {toggleButtonShow && (
              <button
                className="lists-tab"
                onClick={toggleArchiveShowModal}
              >
                Архівувати
              </button>
            )}
            {!toggleButtonShow && (
              <>
                   <button
                  className="lists-tab deploy-btn"
                  onClick={handleDeploy}
                >
                  Деплой
                </button>

                <CustomFilterPicker onSetFilter={customFilters} />

                <button
                  className="lists-tab add-domains-btn"
                  onClick={handleAddDomains}
                >
                  Додати домени
                </button>
                <span className="domains-separator" />
                <button
                  className="lists-tab buy-domains-btn"
                  onClick={handleBuyDomains}
                >
                  Купити домени
                </button>
              </>
            )}
          </div>
          <div className="domains-search">
            {CustomInputGroup({ search, setSearch })}
          </div>
        </div>
      </div>

      <ContainerTable
        onHandleEditingDomain={handleEditingDomain}
        searchQuery={search}
        onToggleButtonShow={toggleButtonShowHidden}
        filterSelectors={filter}
        tableData={data}
        tableHeight={tableHeight}
        onRenewDomain={handleRenewDomain}
      />

      {toglleModallEditingDomain && (
        <EditingRecordsModal
          editingDomainData={editingDomain}
          onEditingModal={editingModal}
          onStaticModal={setEditStaticModal}
          load={load}
           onDomainDataUpdate={domainUpdate}
            />
      )}

      {toglleModallAddDomain && (
        <AddDomainModal
          onClose={handleAddDomains}
        />
      )}
      {toglleModallEditingStatic && (
        <StaticModal
          onSetEditStatic={setEditStaticModal}
          onUploads={uploadStaticToServer}
        />
      )}

      {toglleModallBuyDomain && (
        <BuyDomainModal
          balance={namecheapBalance}
          onClose={handleBuyDomains}
        />
      )}

      {toglleModallArchive && (
        <ArchivedDomainsModal onClose={toggleArchiveShowModal} />
      )}

      {toglleModallDeploy && (
        <DeployModal  onClose={handleDeploy} />
      )}
    </div>
  );
}
